"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Follow(_a) {
    var channel = _a.channel, user = _a.user, className = _a.className;
    if (!user.id) {
        return react_1.default.createElement(storybook_1.Buttons.Link, { icon: 'notification', to: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login/?return=/kanalen/" + channel.name, responsive: false, type: 'primary' }, "Volgen");
    }
    var _b = ra_fetch_1.useApi('backend')
        .index('user_channels', { channel_id: channel.id, user_id: user.id }), subscribed = _b[0], setSubscribed = _b[1];
    var _c = ra_fetch_1.useApi('backend')
        .records(setSubscribed, subscribed.data)
        .store('user_channels', { user_id: user.id, channel_id: channel.id }), userChannels = _c[0], setUserChannels = _c[1], submitUserChannels = _c[2];
    var _d = ra_fetch_1.useApi('backend')
        .records(setSubscribed, subscribed.data)
        .delete('user_channels', { id: channel.id }), deleteUserChannels = _d[0], submitDeleteUserChannels = _d[1];
    var is_subscribed = Boolean(subscribed.data.length);
    function onSubmit() {
        if (is_subscribed) {
            return submitDeleteUserChannels({ id: subscribed.data.first().id });
        }
        submitUserChannels();
    }
    if (subscribed.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Buttons.Button, { className: className, onClick: onSubmit, type: 'primary', icon: 'notification', responsive: false }, is_subscribed ? 'Ontvolgen' : 'Volgen');
}
exports.default = Follow;
